// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d286aa0","667":"5a3dfe90"}[chunkId] + ".chunk.js";
};